module.exports = __webpack_public_path__ + "img/silver1.82204198.png";